angular.module("dx.webapp.masterTools.studentMerge", [
	"dx.webapp.answer",
	"dx.webapp.question",

	"dx.ui.components.dialog",
]);

